<div class="committee">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12  my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#committe-doc'"></app-title-page>
            </div>
            <!-- contents -->
            <div class="col-md-12 documents" id="committe-doc">
                <div class="lane-top">
                    <div class="row mt-5">
                         <!-- Nomination & Remuneration Committee -->
                        <div class="col-md-12">
                            <h3 class="f-subtit mb-3">{{ dataSection[0]?.title }}</h3>
                            <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                        </div>
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit">{{ dataSection[1]?.title }}</h3>
                            <div class="committee-profile mt-3" *ngIf="dataRemunerasi">
                                <div class="row justify-content-center px-md-2 px-3">
                                    <div class="col-md-3 col-6 p-md-2 p-1" *ngFor="let people of dataRemunerasi">
                                        <div class="pointer" (click)="showModal(people)">
                                            <app-people-photos [dataPeople]="people"></app-people-photos>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Audit Committee -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit mb-3">{{ dataSection[2]?.title }}</h3>
                            <div class="desc text-justify" [innerHTML]="dataSection[2]?.content"></div>
                        </div>
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit">{{ dataSection[3]?.title }}</h3>
                            <div class="committee-profile mt-3" *ngIf="dataAudit">
                                <div class="row justify-content-center px-md-2 px-3">
                                    <div class="col-md-3 col-6 p-md-2 p-1" *ngFor="let people of dataAudit">
                                        <div class="pointer" (click)="showModal(people)">
                                            <app-people-photos [dataPeople]="people"></app-people-photos>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Risk Management Committee -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit mb-3">{{ dataSection[4]?.title }}</h3>
                            <div class="desc text-justify" [innerHTML]="dataSection[4]?.content"></div>
                        </div>
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit">{{ dataSection[5]?.title }}</h3>
                            <div class="committee-profile mt-3" *ngIf="dataRisk">
                                <div class="row justify-content-center px-md-2 px-3">
                                    <div class="col-md-3 col-6 p-md-2 p-1" *ngFor="let people of dataRisk">
                                        <div class="pointer" (click)="showModal(people)">
                                            <app-people-photos [dataPeople]="people"></app-people-photos>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- modal board -->
    <div *ngIf="isModalShown" 
        [config]="{ show: true }" 
        (onHidden)="onHidden()" 
        bsModal 
        #autoShownModal="bs-modal"
        class="modal fade modal-director"
        tabindex="-1" 
        role="dialog" 
        aria-labelledby="dialog-auto-name">
        <div class="modal-x" aria-label="Close" (click)="hideModal()">
            <span aria-hidden="true" class="d-flex align-items-center"><i class="icon ion-ios-close"></i> Close</span>
        </div>
        <div class="modal-dialog d-flex align-items-center h-100 my-0 py-4 modal-lg">
            <div class="modal-content">
                <div class="modal-body p-0 d-flex">
                    <div class="detail">
                        <h3 *ngIf="modalPosition" class="position mb-lg-5 mb-4">{{ modalPosition }}</h3>
                        <h5 class="mb-lg-4 mb-3 name">{{ modalName }}</h5>
                        <perfect-scrollbar class="scroll-prof">
                             <div class="prof text-justify" [innerHTML]="modalDetail"></div>
                        </perfect-scrollbar>
                    </div>
                    <div class="pict">
                        <img class="w-100 h-100" [src]="apiAsset + modalImg" [alt]="modalName">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>